import React from 'react';
import { DataList, Loader } from 'commons-ui';
import { useStyletron } from 'baseui';
import { Button } from 'baseui/button';
import useDashboardActions from 'pages/dashboard/useDashboardActions';
import { LIST_ENTITY_NAMES } from 'constant';

import useService from '../../utils/userService';
import useList from './useList';
import { makeActionHandler } from '../../actions/handlers';
import { makeActionList } from '../../actions/list';
import { columnConfigs } from './listConfig';

const CashbackUtilList: React.FC<{}> = () => {
	const { getActionList, getActionHandler } = useDashboardActions(makeActionHandler, makeActionList, {});
	const actions = getActionList();
	const { getConfigList, showLoader } = useService();
	const { redirectToUpdatePriorityList } = useList();
	const [css] = useStyletron();
	const inputBarStyle: string = css({ margin: '20px' });
	const updateFormStyle: string = css({
		width: '500px !important',
		marginRight: '20px'
	});
	return (
		<div>
			{showLoader && <Loader />}
			<div className={inputBarStyle}>
				<div className={updateFormStyle}>
					<span>
						<Button type='button' onClick={redirectToUpdatePriorityList}>
							Check and Update Priority
						</Button>
					</span>
				</div>
			</div>
			<DataList
				fetchData={getConfigList}
				columnConfigs={columnConfigs}
				getActionHandler={getActionHandler}
				actions={actions}
				entity={LIST_ENTITY_NAMES.CASHBACK_UTIL}
				initialSortDirection='ASC'
				initialSortIndex={0}
				filterable={false}
				searchable={false}
			/>
		</div>
	);
};

export default CashbackUtilList;
